import React from 'react';
import { Loader2, X } from 'lucide-react';

interface LoadingOverlayProps {
  isVisible: boolean;
  onCancel?: () => void;
  currentStage?: number;
  totalStages?: number;
  stageNames?: string[];
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isVisible,
  onCancel
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-sm mx-4 text-center">
        {/* Cancel button */}
        {onCancel && (
          <button 
            className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-300"
            onClick={onCancel}
            type="button"
            title="Cancel"
          >
            <X className="w-4 h-4" />
          </button>
        )}

        {/* Spinner and message */}
        <div className="space-y-4">
          <div className="flex justify-center">
            <Loader2 className="w-8 h-8 text-blue-600 animate-spin" />
          </div>
          
          <div className="space-y-2">
            <h3 className="text-lg font-medium text-gray-900">
              Queuing Visit...
            </h3>
            <p className="text-sm text-gray-600">
              This usually takes 20–60 seconds.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};